module.exports = __webpack_public_path__ + "img/pro-zd.96f8276b.png";